import { CampaignsPage } from './pages/app/campaigns/campaigns-page'
import { DealsPage } from './pages/app/deals/deals'
import K12DistrictPage from './pages/app/k12-district-page'
import { AppLayout } from './pages/app/layout'
import { OpportunitiesPage } from './pages/app/opportunities/opportunities'
import { AuthLayout } from './pages/auth/layout'
import Login from './pages/auth/login'
import Register from './pages/auth/register'
import ResetPassword from './pages/auth/reset-password'
import ResetPasswordConfirm from './pages/auth/reset-password-confirm'
import SSOLogin from './pages/auth/sso-login'
import SSOCallback from './pages/auth/sso-callback'
import Verified from './pages/auth/verified'
import { NotFoundContent } from './pages/app/not-found-content'
import { sentryCreateBrowserRouter } from 'services/sentry'
import { Rebates } from 'pages/app/rebates'
import { RebateOfferDetails } from './pages/app/rebates/rebate-offer-details'
import Oops from 'pages/oops'
import LodgingPage from 'pages/app/google_places/lodging'
import LodgingDoorPage from 'pages/app/google_places/lodgingDoor'
import OptOutForm from 'pages/common/opt-out-form'
import DataRequestForm from 'pages/common/data-request-form'
import DataRequestSuccess from 'pages/common/data-request-success'
import OptOutSuccess from 'pages/common/opt-out-success'
import SubscriptionAgreement from 'pages/common/subscription-agreement'
import ConveniencePage from 'pages/app/google_places/convenience'
import ConvenienceDoorPage from 'pages/app/google_places/convenienceDoor'
import {
  ImportPreviewsPage as ImportPreviewsPageV2,
  ImportPreviewPage as ImportPreviewPageV2,
} from 'pages/app/importer-page-v2'
import {
  ImportPreviewsPage,
  ImportPreviewPage,
} from 'pages/app/importer-page-v1'
import { SettingsLayout } from 'pages/app/settings/layout'
import { Settings } from 'pages/app/settings'
import { DoorProxyPage } from 'pages/app/door-proxy-page'
import ProtectedRoute from 'utils/ProtectedRoute'
import RedirectRestaurants from 'utils/RedirectRestaurants'
import { PageWithTitle } from 'utils/PageWithTitle'
import { Dashboard } from 'pages/app/dashboard'
import { ContactsPage } from 'pages/app/contacts/contacts'
import { ActivityPageV2 } from 'pages/app/activity/activityV2'
import { CompanyPage } from 'pages/app/company'
import Restaurant from 'pages/app/restaurant'
import { ChainPage } from 'pages/app/chain-page'
import University from 'pages/app/university'
import HospitalPage from 'pages/app/hospital'
import { Navigate, RouterProvider } from 'react-router-dom'
import NurseHomePage from 'pages/app/nursinghome'
import { SideMenuProvider } from 'features/settings/context/SideMenuContext'
import FeatureProtectedRoute from 'utils/FeatureProtectedRoute'
import { SamplesDashboard } from 'pages/app/samples/SamplesDashboard'
import { SingleCampaignPage } from 'pages/app/campaigns/single-campaign-page'
import Failed from 'pages/auth/failed'
import { CommonLayout } from 'pages/common/layout'
import Terms from 'pages/common/terms'
import Privacy from 'pages/common/privacy'
import RebatePlatformAgreement from 'pages/common/rebates-platform-agreement'
import { DocLibraryPage } from 'pages/DocLibrary'

export default function Desktop() {
  const appRouter = sentryCreateBrowserRouter([
    {
      path: '',
      element: (
        <ProtectedRoute>
          <RedirectRestaurants />
        </ProtectedRoute>
      ),
    },
    {
      path: '/',
      element: <AppLayout />,
      errorElement: <Oops />,
      children: [
        {
          path: '',
          element: (
            <ProtectedRoute>
              <RedirectRestaurants />
            </ProtectedRoute>
          ),
        },
        {
          path: 'dashboard',
          element: (
            <ProtectedRoute>
              <PageWithTitle title="Dashboard">
                <Dashboard />
              </PageWithTitle>
            </ProtectedRoute>
          ),
        },
        {
          path: 'contacts/:type?/',
          element: (
            <ProtectedRoute>
              <PageWithTitle title="Contacts">
                <ContactsPage />
              </PageWithTitle>
            </ProtectedRoute>
          ),
        },
        {
          path: 'activity/:type?/',
          element: (
            <ProtectedRoute>
              <PageWithTitle title="Activity">
                <ActivityPageV2 />
              </PageWithTitle>
            </ProtectedRoute>
          ),
        },
        {
          path: 'company/:company_id',
          element: (
            <ProtectedRoute>
              <PageWithTitle title="Company">
                <CompanyPage />
              </PageWithTitle>
            </ProtectedRoute>
          ),
        },
        {
          path: 'opportunities/',
          element: (
            <ProtectedRoute>
              <RedirectRestaurants />
            </ProtectedRoute>
          ),
        },
        {
          path: 'opportunities/:category/:sub_category/',
          element: (
            <ProtectedRoute>
              <PageWithTitle title="Opportunities">
                <OpportunitiesPage />
              </PageWithTitle>
            </ProtectedRoute>
          ),
        },
        // TODO determine url paths
        {
          path: 'restaurant/:firstbite_id',
          element: (
            <ProtectedRoute>
              <PageWithTitle title="Restaurant">
                <Restaurant />
              </PageWithTitle>
            </ProtectedRoute>
          ),
        },
        {
          path: 'door/:door_proxy_id',
          element: (
            <ProtectedRoute>
              <PageWithTitle title="Door">
                <DoorProxyPage />
              </PageWithTitle>
            </ProtectedRoute>
          ),
        },
        {
          path: 'chain/:chain_name',
          element: (
            <ProtectedRoute>
              <PageWithTitle title="Chain">
                <ChainPage />
              </PageWithTitle>
            </ProtectedRoute>
          ),
        },
        {
          path: 'university/:university_name',
          element: (
            <ProtectedRoute>
              <PageWithTitle title="University">
                <University />
              </PageWithTitle>
            </ProtectedRoute>
          ),
        },
        {
          path: 'k12/:id/',
          element: (
            <ProtectedRoute>
              <PageWithTitle title="K12 District">
                <K12DistrictPage />
              </PageWithTitle>
            </ProtectedRoute>
          ),
        },
        {
          path: 'hospital/:hospital_id',
          element: (
            <ProtectedRoute>
              <PageWithTitle title="Hospital">
                <HospitalPage />
              </PageWithTitle>
            </ProtectedRoute>
          ),
        },
        {
          path: 'lodging/chain/:lodging_id',
          element: (
            <ProtectedRoute>
              <PageWithTitle title="Lodging & Hospitality">
                <LodgingPage />
              </PageWithTitle>
            </ProtectedRoute>
          ),
        },
        {
          path: 'lodging/door/:lodging_id',
          element: (
            <ProtectedRoute>
              <PageWithTitle title="Lodging & Hospitality">
                <LodgingDoorPage />
              </PageWithTitle>
            </ProtectedRoute>
          ),
        },
        {
          path: 'convenience/chain/:convenience_id',
          element: (
            <ProtectedRoute>
              <PageWithTitle title="Convenience Store">
                <ConveniencePage />
              </PageWithTitle>
            </ProtectedRoute>
          ),
        },
        {
          path: 'convenience/door/:convenience_id',
          element: (
            <ProtectedRoute>
              <PageWithTitle title="Convenience Store">
                <ConvenienceDoorPage />
              </PageWithTitle>
            </ProtectedRoute>
          ),
        },
        {
          path: 'nursinghome/:nursinghome_id',
          element: (
            <ProtectedRoute>
              <PageWithTitle title="Nursing Home">
                <NurseHomePage />
              </PageWithTitle>
            </ProtectedRoute>
          ),
        },
        {
          path: 'product',
          element: <Navigate to="/settings/products" replace />,
        },
        {
          path: 'settings/:group?/:tab?',
          element: (
            <ProtectedRoute>
              <PageWithTitle title="Settings">
                <SideMenuProvider>
                  <SettingsLayout />
                </SideMenuProvider>
              </PageWithTitle>
            </ProtectedRoute>
          ),
          children: [
            {
              path: '',
              element: <Settings />,
            },
          ],
        },
        {
          path: 'deals',
          element: (
            <ProtectedRoute>
              <PageWithTitle title="Deals">
                <DealsPage />
              </PageWithTitle>
            </ProtectedRoute>
          ),
        },
        {
          path: 'campaigns',
          element: (
            <ProtectedRoute>
              <PageWithTitle title="Campaigns">
                <CampaignsPage />
              </PageWithTitle>
            </ProtectedRoute>
          ),
        },
        {
          path: 'samples/:type?/',
          element: (
            <ProtectedRoute>
              <FeatureProtectedRoute featureFlag="enableSamples">
                <PageWithTitle title="Samples">
                  <SamplesDashboard />
                </PageWithTitle>
              </FeatureProtectedRoute>
            </ProtectedRoute>
          ),
        },
        {
          path: 'documents/:tab?',
          element: (
            <ProtectedRoute>
              <FeatureProtectedRoute featureFlag="enableDocumentLibrary">
                <PageWithTitle title="Documents">
                  <DocLibraryPage />
                </PageWithTitle>
              </FeatureProtectedRoute>
            </ProtectedRoute>
          ),
        },
        {
          path: 'campaigns/:campaign_id/:tab?',
          element: (
            <ProtectedRoute>
              <SingleCampaignPage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'rebates/:tab?',
          element: (
            <ProtectedRoute>
              <Rebates />
            </ProtectedRoute>
          ),
        },
        {
          path: 'rebates/offer/:offerId/:tab?',
          element: (
            <ProtectedRoute>
              <FeatureProtectedRoute featureFlag="enableRebates">
                <PageWithTitle title="Rebate Offer">
                  <RebateOfferDetails />
                </PageWithTitle>
              </FeatureProtectedRoute>
            </ProtectedRoute>
          ),
        },
        {
          path: '*',
          element: (
            <ProtectedRoute>
              <PageWithTitle title="Page Not Found">
                <NotFoundContent />
              </PageWithTitle>
            </ProtectedRoute>
          ),
        },
      ],
    },
    {
      path: '/login',
      element: <AuthLayout />,
      children: [
        {
          path: '',
          element: (
            <PageWithTitle title="Log-in">
              <Login />
            </PageWithTitle>
          ),
        },
      ],
    },
    {
      path: '/signup',
      element: <AuthLayout />,
      children: [
        {
          path: '',
          element: (
            <PageWithTitle title="Sign-up">
              <Register />
            </PageWithTitle>
          ),
        },
      ],
    },
    {
      path: '/sso-login',
      element: <AuthLayout />,
      children: [
        {
          path: '',
          element: (
            <PageWithTitle title="SSO Login">
              <SSOLogin />
            </PageWithTitle>
          ),
        },
      ],
    },
    {
      path: '/auth/sso-callback',
      element: (
        <PageWithTitle title="SSO Authentication">
          <SSOCallback />
        </PageWithTitle>
      ),
    },
    {
      path: '/email-verified-confirmation',
      element: <AuthLayout />,
      children: [
        {
          path: '',
          element: (
            <PageWithTitle title="Email Verified">
              <Verified />
            </PageWithTitle>
          ),
        },
      ],
    },
    {
      path: '/email-verification-failed',
      element: <AuthLayout />,
      children: [
        {
          path: '',
          element: (
            <PageWithTitle title="Email Verification Failed">
              <Failed />
            </PageWithTitle>
          ),
        },
      ],
    },
    {
      path: '/reset-password',
      element: <AuthLayout />,
      children: [
        {
          path: '',
          element: (
            <PageWithTitle title="Reset Password">
              <ResetPassword />
            </PageWithTitle>
          ),
        },
      ],
    },
    {
      path: '/password-reset-confirm/:uid/:token',
      element: <AuthLayout />,
      children: [
        {
          path: '',
          element: (
            <PageWithTitle title="Reset Password Confirmation">
              <ResetPasswordConfirm />
            </PageWithTitle>
          ),
        },
      ],
    },
    {
      path: '/terms-of-use',
      element: <CommonLayout />,
      children: [
        {
          path: '',
          element: (
            <PageWithTitle title="Terms of Use">
              <Terms />
            </PageWithTitle>
          ),
        },
      ],
    },
    {
      path: '/privacy-policy',
      element: <CommonLayout />,
      children: [
        {
          path: '',
          element: (
            <PageWithTitle title="Privacy Policy">
              <Privacy />
            </PageWithTitle>
          ),
        },
      ],
    },
    {
      path: '/subscription-agreement',
      element: <CommonLayout />,
      children: [
        {
          path: '',
          element: (
            <PageWithTitle title="Subscription Agreement">
              <SubscriptionAgreement />
            </PageWithTitle>
          ),
        },
      ],
    },
    {
      path: '/rebate-platform-agreement',
      element: <CommonLayout />,
      children: [
        {
          path: '',
          element: (
            <PageWithTitle title="Rebate Platform Agreement">
              <RebatePlatformAgreement />
            </PageWithTitle>
          ),
        },
      ],
    },
    {
      path: '/opt-out-form',
      element: <CommonLayout />,
      children: [
        {
          path: '',
          element: (
            <PageWithTitle title="Opt Out Form">
              <OptOutForm />
            </PageWithTitle>
          ),
        },
      ],
    },
    {
      path: '/data-request-form',
      element: <CommonLayout />,
      children: [
        {
          path: '',
          element: (
            <PageWithTitle title="Data Request Form">
              <DataRequestForm />
            </PageWithTitle>
          ),
        },
      ],
    },
    {
      path: '/data-request-success',
      element: <CommonLayout />,
      children: [{ path: '', element: <DataRequestSuccess /> }],
    },
    {
      path: '/opt-out-success',
      element: <CommonLayout />,
      children: [{ path: '', element: <OptOutSuccess /> }],
    },
    {
      path: '/importer',
      element: (
        <FeatureProtectedRoute featureFlag="enableNewImportTool">
          <CommonLayout />
        </FeatureProtectedRoute>
      ),
      children: [
        { path: '', element: <ImportPreviewsPage /> },
        { path: ':import_number', element: <ImportPreviewPage /> },
      ],
    },
    {
      path: '/importer/v2',
      element: (
        <FeatureProtectedRoute featureFlag="enableNewImportTool">
          <CommonLayout />
        </FeatureProtectedRoute>
      ),
      children: [
        { path: '', element: <ImportPreviewsPageV2 /> },
        { path: ':import_number', element: <ImportPreviewPageV2 /> },
      ],
    },
  ])

  return <RouterProvider router={appRouter} />
}
